(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9180],{

/***/ 80945:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Example; }
});

// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/views/Marketing/Blog/components/BlogPage/index.tsx
var BlogPage = __webpack_require__(32526);
// EXTERNAL MODULE: ./src/views/Marketing/components/Footer/index.tsx
var Footer = __webpack_require__(45867);
// EXTERNAL MODULE: ./src/views/Marketing/components/NavBar/index.tsx
var NavBar = __webpack_require__(82969);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/ScrollView/index.js
var ScrollView = __webpack_require__(38174);
var ScrollView_default = /*#__PURE__*/__webpack_require__.n(ScrollView);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/cjs/exports/StyleSheet/index.js
var StyleSheet = __webpack_require__(84099);
var StyleSheet_default = /*#__PURE__*/__webpack_require__.n(StyleSheet);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/views/Marketing/Blog/marketing/grailed-seller-protection/index.tsx







function Page() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((ScrollView_default()), {
    style: styles.scrollView,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(NavBar/* default */.Z, {}), /*#__PURE__*/(0,jsx_runtime.jsxs)(BlogPage/* default */.Z, {
      author: "OneShop Team",
      dateTime: "2022-05-15",
      tag: "Grailed",
      title: "Selling with confidence with Grailed Seller Protection",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Grailed prides itself on having team members and a community of sellers and buyers that uphold the high standards established by the platform. However, as no marketplace is perfect, there are instances when buyers need to be duly refunded, or sellers need to recover the amount lost from false claims."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["In these cases, Grailed ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Money Back Guarantee"
        }), " will protect either the buyer or the seller, depending on the circumstances. This article will focus on how Grailed protects its sellers and what must be done to make sure they stay protected in every transaction."]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Here are three common scenarios why sellers need the ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "Seller Protection"
        }), ":"]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("ul", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: " The item you shipped out did not reach the buyer."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: " The received item allegedly doesn\u2019t match the listing description."
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: " The buyer files a refund claim for the item received."
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Sellers and buyers may resolve these cases among themselves amicably, with the refund going to the aggrieved party. Otherwise, Grailed\u2019s support team will review the cases thoroughly before coming up with a resolution. They will look at the case\u2019s eligibility, which we will discuss in detail below."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "How to be eligible for seller protection on Grailed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "First, you must ensure that the transaction was done entirely on the Grailed platform, including payment. This covers payments made using PayPal checkout."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "What is not covered are sales with offsite transactions involved \u2013 either using other platforms or through arranged meetups. Always be wary of potential buyers luring you to continue your transaction elsewhere. You can help keep Grailed safe by reporting these users."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Second, make sure that the item was shipped to a valid address and that you have active tracking information on hand. If the item is worth at least $750 (total price including taxes and shipping), sellers are required to request signature confirmation upon delivery for added security."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is necessary to provide PayPal with the tracking information to be covered by their seller protection program for PayPal payments. Remember to enter these essential details into the system so that you may be reimbursed if needed. Be prepared to support your claim with as many clear, convincing pieces of evidence as you can gather. If you feel that PayPal has not decidedly fairly on your case, you may reach out to the Grailed support team for assistance."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Third, you must report the issue or file a claim against the buyer no more than 180 days after you made the sale. Do it as soon as you have gathered the evidence you need. Also, to stay on top of the issue, always check for Grailed or PayPal messages and reply promptly. Sometimes, these may land in your spam folder, so be sure to check that."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "Upholding the Zero-Fraud Policy on Grailed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Aside from its Money-Back Guarantee, Grailed protects sellers and buyers through its Zero-Fraud Policy. Since Grailed is known for mostly designer labels, high-end brands, and limited-edition pieces, they strictly and regularly check the platform for any counterfeits or stolen product photos posted by scammer sellers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Legitimate sellers benefit from this policy because their listing photos and descriptions are protected from theft. The vigilant marketplace monitoring ensures that the competition is limited only to real sellers; scammers and shady sellers are weeded out. Grailed also bans buyers with repeated suspicious behavior, which minimizes your risk of transacting with bogus buyers."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "It is important to know your rights as a seller and how the marketplace you engage with can protect you in unfortunate cases. Seller protection may vary from one platform to another, so be sure to check the policy of each one if you sell in places other than Grailed."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        children: "A savvy tool for growing your reselling business"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        children: "Selling in two or more marketplaces is great for exposure. It increases your listings\u2019 chances of getting sold faster. However, manually cross-listing and delisting can easily get confusing and mess up your inventory. OneShop specializes in automating these tasks for you, so you can focus on strategies to scale up your business. Let it save you time by quickly creating drafts that can be cross-listed on different platforms."
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
        children: ["Thousands of online resellers trust OneShop as it is an all-in-one tool that can help you increase your sales and ultimately grow your business. Spending right away to see if it works for you should not be a problem as there is no payment required until after the trial. ", /*#__PURE__*/(0,jsx_runtime.jsx)("a", {
          href: "https://tools.oneshop.com/signup",
          children: "Sign-up now"
        }), ' ', "and take advantage of its amazing features with its 7-day free trial!"]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* default */.Z, {})]
  });
}
var styles = StyleSheet_default().create({
  scrollView: {
    flex: 1
  }
});
;// CONCATENATED MODULE: ./src/pages/blog/grailed-seller-protection.tsx





function Example() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)((head_default()), {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("title", {
        children: "Selling with confidence with Grailed Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        name: "description",
        content: "Grailed assures sellers of protected sales for transactions that fully meet their criteria with its Money-Back Guarantee. Find out how to ensure your sales are covered every time."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("link", {
        rel: "canonical",
        href: "https://tools.oneshop.com/blog/grailed-seller-protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:url",
        content: "https://tools.oneshop.com/blog/grailed-seller-protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:title",
        content: "Selling with confidence with Grailed Seller Protection"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:description",
        content: "Grailed assures sellers of protected sales for transactions that fully meet their criteria with its Money-Back Guarantee. Find out how to ensure your sales are covered every time."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "og:image",
        content: "https://tools.oneshop.com/static/images/og-image.png?v=3"
      }, 'og-image'), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:published_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:modified_time",
        content: "2022-05-15T00:00:00-00:00"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:tag",
        content: "Grailed"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("meta", {
        property: "article:publisher",
        content: "https://www.facebook.com/oneshopcompany"
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Page, {})]
  });
}

/***/ }),

/***/ 39630:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/grailed-seller-protection",
      function () {
        return __webpack_require__(80945);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2678,4885,8409,8908,8776,8174,6770,1664,4965,9561,5675,1577,6554,858,275,9774,2888,179], function() { return __webpack_exec__(39630); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);